import React from "react";
import { message, Modal, Row, Tabs, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import ProductInformationTab from "./ProductInformationTab";
import ProductSummaryTab from "./ProductSummaryTab";
import VariantTransferTab, { WsProductExtended } from "./VariantTransferTab";
import {
  useCreateWsProductMutation,
  useUpdateWsProductMutation,
  useTransferWsVariantsMutation,
  useDeleteWsProductMutation,
} from "../../../api/webshop/wsProductsApi";

export default function EditProductModal(props: {
  title: string;
  pg?: WsProductExtended;
  setPg: (pg: WsProductExtended) => void;
  onClose: () => void;
}) {
  const [createProduct] = useCreateWsProductMutation();
  const [updateProduct] = useUpdateWsProductMutation();
  const [transferVariants] = useTransferWsVariantsMutation();
  const [deleteProduct] = useDeleteWsProductMutation();
  const [messageApi, ctxHolder] = message.useMessage();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [activeTabKey, setActiveTabKey] = React.useState("1");

  const handleDeleteConfirm = () => {
    if (!props.pg?.productId) return;
    deleteProduct(props.pg.productId)
      .unwrap()
      .then(() => {
        messageApi.success("Product deleted successfully");
        setIsDeleteModalOpen(false);
        props.onClose();
      })
      .catch((err) => {
        console.error("Error deleting product:", err);
        messageApi.error("Error deleting product.");
      });
  };

  const tabs = [
    {
      key: "1",
      label: "Product Information",
      children: props.pg && (
        <ProductInformationTab p={props.pg} setP={props.setPg} />
      ),
    },
    {
      key: "2",
      label: "Variant Management",
      children: props.pg && (
        <VariantTransferTab p={props.pg} setP={props.setPg} />
      ),
    },
    {
      key: "3",
      label: "Summary",
      children: props.pg && (
        <ProductSummaryTab p={props.pg} setP={props.setPg} />
      ),
    },
  ];

  const handleSave = () => {
    if (!props.pg) {
      return;
    }

    const isCreating = !props.pg.productId;
    console.log("Saving webshop product:", props.pg, "isCreating:", isCreating);

    const saveAction = isCreating
      ? createProduct(props.pg)
      : updateProduct(props.pg);
    console.log("update product", props.pg);
    saveAction
      .unwrap()
      .then(async () => {
        // Trigger variant transfer API if variants are assigned

        messageApi.success("Saved product data successfully");

        props.onClose();
      })
      .catch((err) => {
        console.error("Error saving product:", err);
        // Show warning/error message but still allow closing/logging for placeholder testing
        messageApi.error(
          "Error calling save product API. (Check console logs for placeholder payload details)",
        );
        props.onClose();
      });
  };

  return (
    <>
      {ctxHolder}
      <Modal
        title={props.title}
        open={!!props.pg}
        onOk={handleSave}
        onCancel={props.onClose}
        width={"80%"}
        okText="Save"
        cancelText="Cancel"
        footer={activeTabKey === "2" || activeTabKey === "3" ? null : undefined}
        destroyOnClose
      >
        {props.pg && (
          <Tabs
            type="card"
            activeKey={activeTabKey}
            onChange={setActiveTabKey}
            items={tabs}
            tabBarExtraContent={
              props.pg.productId ? (
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => setIsDeleteModalOpen(true)}
                >
                  Delete Product
                </Button>
              ) : null
            }
          />
        )}
      </Modal>
      <Modal
        title="Delete Product"
        open={isDeleteModalOpen}
        onOk={handleDeleteConfirm}
        onCancel={() => setIsDeleteModalOpen(false)}
        okText="Confirm"
        cancelText="Go Back"
        okButtonProps={{ danger: true }}
        centered
        width={400}
        zIndex={1050}
      >
        <p>Warning: Deleting a product will delete all its variants.</p>
        <p>Are you sure you want to proceed?</p>
      </Modal>
    </>
  );
}
